function secondsToTime (e) {
  const h = Math.floor(e / 3600).toString().padStart(2, '0')
  const m = Math.floor(e % 3600 / 60).toString().padStart(2, '0')
  // const s = Math.floor(e % 60).toString().padStart(2, '0')
  // return `${h}:${m}:${s}`
  return `${h}:${m}`
}
const COURSES = {
  62: {
    'role': 'user',
    'teams': [],
    'stores': []
  },
  68: {
    'role': 'user',
    'teams': [],
    'stores': []
  },
  69: {
    'role': 'user',
    'teams': [],
    'stores': []
  }
}
const state = {
  courses: COURSES,
  details: {},
  firstName: '',
  phoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  lastName: '',
  country: false,
  state: false,
  userId: 0,
  userImageUrl: '',
  game: {
    id: 0,
    players: []
  },
  tracking: true,
  totalSeconds: 0,
  localTraining: null
}

// getters
const getters = {
  getTotalSeconds (state) {
    return state.totalSeconds
  },
  getTrackedTime (state) {
    return secondsToTime(state.totalSeconds)
  },
  getTracking (state) {
    return state.tracking
  },
  getUserId (state) {
    return state.userId
  },
  getFirstName (state) {
    return state.firstName
  },
  getLastName (state) {
    return state.lastName
  },
  getCountry (state) {
    return state.country
  },
  getState (state) {
    return state.state
  },
  getCourses (state) {
    return state.courses ? state.courses : COURSES
  },
  getGameAllPlayers (state) {
    return state.game.players
  },
  getGameId (state) {
    return state.game.id
  },
  getUserDetails (state) {
    return state.details
  },
  userFullName (state) {
    return state.firstName + ' ' + state.lastName
  },
  avatar (state) {
    if (state.userImageUrl && state.userImageUrl.includes('playerservice/user')) {
      return process.env.API_URL + state.userImageUrl
    } else {
      return state.userImageUrl
    }
  },
  avatarLetters () {
    if (typeof state.details.firstName === 'undefined') {
      return ''
    } else {
      return state.details.firstName.charAt(0) + ' ' + state.details.lastName.charAt(0)
    }
  },
  getPhone (state) {
    return state.phoneNumber
  },
  getAddressLine1 (state) {
    return state.addressLine1
  },
  getAddressLine2 (state) {
    return state.addressLine2
  },
  getCity (state) {
    return state.city
  },
  getPostalCode (state) {
    return state.postalCode
  },
  getLocalTraining (state) {
    return state.localTraining
  },
  hasLocalTraining (state) {
    if (!state.localTraining) return false
    return !!(state.localTraining.trainingLink || state.localTraining.trainingLinkLabel)
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  setCourses (state, details) {
    if (details) {
      state.courses = details
    }
  },
  setUserId (state, id) {
    state.userId = id
  },
  setFirstName (state, detail) {
    state.firstName = detail
  },
  setLastName (state, detail) {
    state.lastName = detail
  },
  setCountry (state, detail) {
    state.country = detail
  },
  setState (state, detail) {
    state.state = detail
  },
  setUserDetails (state, details) {
    state.details = details
  },
  setAvatar (state, newValue) {
    state.userImageUrl = newValue
  },
  setPhone (state, newValue) {
    state.phoneNumber = newValue
  },
  setAddressLine1 (state, newValue) {
    state.addressLine1 = newValue
  },
  setAddressLine2 (state, newValue) {
    state.addressLine2 = newValue
  },
  setCity (state, newValue) {
    state.city = newValue
  },
  setPostalCode (state, newValue) {
    state.postalCode = newValue
  },
  setTracking (state, newVal) {
    state.tracking = newVal
  },
  setTotalSeconds (state, newVal) {
    state.totalSeconds = newVal
  },
  setLocalTraining (state, payload) {
    state.localTraining = payload
  },
  resetUser (state, newVal) {
    state.details = {}
    state.firstName = newVal
    state.phoneNumber = ''
    state.addressLine1 = ''
    state.addressLine2 = ''
    state.postalCode = ''
    state.city = ''
    state.lastName = ''
    state.country = false
    state.state = false
    state.userId = 0
    state.userImageUrl = ''
    state.game = {
      id: 0,
      players: []
    }
    state.tracking = true
    state.totalSeconds = 0
    state.localTraining = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js